export default "__VITE_ASSET__a304b7db__"